<template>
    <div class="grid md:grid-cols-12 gap-4 py-24">
        <div class="md:col-span-5">
            <h6 class="text-5xl font-bold text-white font-secondary high-contrast:text-dark">
                {{ title }}
            </h6>
        </div>

        <div class="md:col-span-7">
            <p class="text-white text-xl pt-5">{{ __('Wybierz swoje ulubione gatunki w celu jak najlepszej personalizacji newslettera') }}:</p>

            <form method="post" class="mt-6" @submit.prevent="validateSelections">
                <div class="flex flex-col sm:flex-row sm:space-x-4 w-full mb-3 gap-4">
                    <input-text
                        v-model="subscriber.email"
                        name="email"
                        class="w-full"
                        required
                        :label="__('Twój adres email')"
                        :errors="errors"
                        colorClass="border border-white placeholder-white/75 text-white"
                    />
                    <v-select
                        v-model="subscriber.genres"
                        :options="genres"
                        :reduce="genre => genre.id"
                        label="name"
                        multiple
                        :placeholder="__('Wybierz gatunki muzyczne')"
                        class="w-full v-select-white"
                        :errors="errors"
                    ></v-select>
                </div>
                <div class="grid mt-2">
                    <input-checkbox
                        name="has_full_subscription"
                        class="sm:col-span-2 newsletter-form"
                        v-model="subscriber.has_full_subscription"
                        :HTMLcontent="__(fullSubscriptionLabel)"
                        label-class="!text-lg text-white"
                        :errors="errors"
                    />
                    <input-checkbox
                        name="consent"
                        class="sm:col-span-2 newsletter-form"
                        v-model="subscriber.consent"
                        :HTMLcontent="__(consentLabel)"
                        label-class="!text-lg text-white"
                        required
                        :errors="errors"
                    />
                </div>

                <div class="flex justify-end mt-6">
                    <div>
                        <button
                            type="submit"
                            class="flex items-center justify-center w-full px-4 py-3 my-0 text-xl text-black rounded bg-white font-secondary high-contrast:bg-yellow-300 high-contrast:text-black"
                            style="padding: 0.875rem 1rem;"
                        >
                            <span>{{ __('Wyślij') }}</span>
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import InputText from "@/front/components/Inputs/Text";
import vSelect from 'vue-select';
import InputCheckbox from "@/front/components/Inputs/Checkbox";
import ArrowRight from '@/front/components/Icons/ArrowRight';

const DEFAULT_SUBSCRIBER_DATA = {
    email: '',
    genres: [],
    consent: false,
    has_full_subscription: false,
};

export default {
    name: 'Newsletter',
    components: {
        InputText,
        vSelect,
        InputCheckbox,
        ArrowRight
    },
    props: {
        genres: {
            type: Array,
            required: true
        },
        title: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            errors: {},
            message: '',
            localIsSendingInProgress: this.isSendingInProgress,
            subscriber: _.cloneDeep(DEFAULT_SUBSCRIBER_DATA),
            isSendingInProgress: false,
            consentLabel: "Zgadzam się na przetwarzanie moich danych osobowych w zakresie opisanym w <a href='/dla-klienta/polityka-prywatnosci' class='text-orange underline'>Polityce Prywatności</a>",
            fullSubscriptionLabel: "Chcę otrzymywać wszystkie informacje"
        };
    },
    methods: {
        validateSelections() {
            this.localIsSendingInProgress = true;
            this.errors = {};
            this.message = '';

            axios
                .post(route('json.newsletter.save'), this.subscriber)
                .then(response => {
                    let message = _.get(response, 'data.message');

                    if (message) {
                        swal.fire("", message, "success");
                    }

                    this.setStateClear();
                })
                .catch(response => {
                    if (response.response.status === 422) {
                        this.errors = _.get(response.response, 'data.errors');

                        return;
                    }

                    let errorMessage = _.get(response.response, 'data.message');

                    if (errorMessage) {
                        swal.fire("", errorMessage , 'warning');
                    }
                })
                .finally(() => {
                    this.localIsSendingInProgress = false;
                });
        },
        setStateClear() {
            this.errors = {};
            this.subscriber = _.cloneDeep(DEFAULT_SUBSCRIBER_DATA);
        }
    }
};
</script>